import { render, staticRenderFns } from "./ChannelWindow.vue?vue&type=template&id=6e37a790"
import script from "./ChannelWindow.vue?vue&type=script&lang=js"
export * from "./ChannelWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports